module.exports = __webpack_public_path__ + "img/clock-2.9ed3aaf3.svg";